import type {ReactNode} from 'react';
import {useNavigate} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {usePathToOfferView} from 'components/upselling/usePathToOfferView';
import {usePrivacyPolicyLink} from 'hooks/usePrivacyPolicyLink';
import {useReservation} from 'context/reservation';
import {POSTHOG_EVENTS, useAnalytics} from 'analytics';
import {VelaChatLink} from './VelaChat';

type OfferLinkProps = {
  offerId: string;
  children: ReactNode;
};

function VelaOfferLink({offerId, children}: OfferLinkProps) {
  const navigate = useNavigate();
  const {track} = useAnalytics();
  const {getFullPathToOfferView} = usePathToOfferView();

  const handleClick = () => {
    track(POSTHOG_EVENTS.RECOMMENDATIONS_CLICKED);
    navigate(getFullPathToOfferView(offerId));
  };

  return <VelaChatLink onClick={handleClick}>{children}</VelaChatLink>;
}

function VelaPrivacyPolicyLink() {
  const {t} = useTranslation();
  const {housingId} = useReservation();
  const {href} = usePrivacyPolicyLink({housingId});

  if (!href) return null;

  return <VelaChatLink href={href}>{t('read_our_privacy_policy')}</VelaChatLink>;
}

export {VelaOfferLink, VelaPrivacyPolicyLink};
